import { useQuery } from '@tanstack/react-query';
import { TEmailTemplate } from 'components/FlowBuilder/FlowSidePanels/types';
import emailService from 'services/api/email.api';

type UseEmailTemplatesOptions = {
  enabled?: boolean;
};

const useEmailTemplates = (options: UseEmailTemplatesOptions = {}) => {
  const { enabled = true } = options;
  const { data, isLoading, isFetching, error, refetch } = useQuery<TEmailTemplate[], Error>({
    queryKey: ['email-templates'],
    queryFn: () => emailService.getEmailTemplates(),
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    emailTemplates: data || [],
    areEmailTemplatesLoading: isLoading,
    areEmailTemplatesFetching: isFetching,
    emailTemplatesError: error,
    refetchEmailTemplates: refetch,
  };
};

export default useEmailTemplates;
